import createField from "../../utils/factory/createField";
import {
  faBox,
  faCogs,
  faSortNumericUp,
  faMapMarkerAlt,
  faLocationArrow,
  faInfoCircle,
  faKey,
  faTags,
  faClipboardCheck,
  faBoxOpen,
  faFileAlt,
  faLocationPin,
} from "@fortawesome/free-solid-svg-icons";

export const DetailsOsItemFields = [
  {
    section: "Item da Requisição",
    fields: [
      createField({
        id: "contract_item",
        label: "Item do Contrato",
        type: "text",
        icon: faCogs,
        disabled: true,
      }),
      createField({
        id: "product",
        label: "Insumo",
        type: "text",
        icon: faCogs,
        disabled: true,
      }),
      createField({
        id: "movementType",
        label: "Tipo de Movimento",
        type: "text",
        icon: faBox,
        disabled: true,
      }),
      createField({
        id: "department",
        label: "Departamento",
        type: "text",
        icon: faClipboardCheck,
        disabled: true,
      }),
      createField({
        id: "quantity",
        label: "Quantidade",
        type: "number",
        icon: faSortNumericUp,
        disabled: true,
      }),
      createField({
        id: "quantity_product",
        label: "Quantidade",
        type: "number",
        icon: faSortNumericUp,
        disabled: true,
      }),
      createField({
        id: "address",
        label: "Endereço",
        type: "text",
        icon: faMapMarkerAlt,
        disabled: true,
      }),
      createField({
        id: "location",
        label: "Localização",
        type: "text",
        icon: faLocationArrow,
        disabled: true,
      }),
      createField({
        id: "details",
        label: "Detalhes",
        type: "textarea",
        fullWidth: true,
        icon: faInfoCircle,
        disabled: true,
      }),
    ],
  },
];

export const baseOsItemFields = [
  {
    section: "Item da Requisição",
    fields: [
      createField({
        id: "contract_item_id",
        label: "Item do Contrato",
        type: "select",
        placeholder: "Digite o identificador",
        icon: faKey,
      }),
      createField({
        id: "product_id",
        label: "Insumo",
        type: "select",
        placeholder: "Digite o identificador",
        icon: faKey,
      }),
      createField({
        id: "movement_type_id",
        label: "Tipo de Movimento",
        type: "multi-select",
        placeholder: "Selecione o tipo",
        icon: faTags,
        disabled: true,
      }),
      createField({
        id: "department_id",
        label: "Departamento",
        type: "select",
        placeholder: "Selecione o departamento",
        icon: faKey,
      }),
      createField({
        id: "quantity",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a quantidade",
        icon: faSortNumericUp,
      }),
      createField({
        id: "quantity_product",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a quantidade",
        icon: faSortNumericUp,
      }),
      createField({
        id: "address_id",
        label: "Endereço",
        type: "multi-select",
        placeholder: "Selecione o endereço",
        icon: faMapMarkerAlt,
      }),
      createField({
        id: "location_id",
        label: "Localização",
        type: "multi-select",
        placeholder: "Selecione a localização",
        icon: faLocationArrow,
      }),
      createField({
        id: "details",
        label: "Detalhes",
        type: "textarea",
        fullWidth: true,
        placeholder: "Digite os detalhes",
        icon: faInfoCircle,
      }),
    ],
  },
];

export const osItemFields = [
  {
    section: "Item",
    fields: [
      createField({
        id: "item_type",
        label: "Tipo de item",
        type: "select",
        placeholder: "Selecione o tipo de item",
        icon: faKey,
        fullWidth: true,
      }),
    ],
  },
  {
    section: "Equipamentos",
    array: true,
    fields: [
      createField({
        id: "equipments.movement_type_id",
        label: "Tipo de Movimento",
        type: "select",
        placeholder: "Digite o tipo de movimento",
        icon: faClipboardCheck,
        isClearable: true,
      }),
      createField({
        id: "equipments.department_id",
        label: "Departamento",
        type: "select",
        placeholder: "Selecione o departamento",
        icon: faClipboardCheck,
        isClearable: true,
      }),
      // TODO: ALUGUEL
      createField({
        id: "equipments.is_exchange",
        label: "É permuta?",
        type: "select",
        placeholder: "Selecione se é permuta ou não",
        fullWidth: true,
        icon: faBoxOpen,
      }),
      // Se o is_exchange for sim renderizar os campos abaixo
      createField({
        id: "equipments.product_id",
        label: "Tipo de equipamento que será envido",
        type: "select",
        placeholder: "Selecione o tipo de equipamento",
        icon: faBoxOpen,
      }),
      createField({
        id: "equipments.alias",
        label: "Descrição do equipamento",
        type: "text",
        placeholder: "Ex: MICRO I5 16GB RAM 256 SSD",
        icon: faBoxOpen,
      }),
      createField({
        id: "equipments.price",
        label: "Preço",
        type: "number",
        isNumericFormat: true,
        placeholder: "Digite o preço",
        icon: faBoxOpen,
      }),
      // Se o is_exchange for não renderizar os campos abaixo
      createField({
        id: "equipments.contract_item_id",
        label: "Item do Contrato",
        type: "select",
        placeholder: "Selecione o item do contrato",
        icon: faBoxOpen,
      }),
      createField({
        id: "equipments.quantity",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
      }),
      createField({
        id: "equipments.address_id",
        label: "Endereço",
        type: "select",
        placeholder: "Selecione o endereço",
        icon: faMapMarkerAlt,
      }),
      createField({
        id: "equipments.location_id",
        label: "Localização",
        type: "select",
        placeholder: "Selecione a localização",
        icon: faMapMarkerAlt,
        notRequired: true,
      }),
      createField({
        id: "equipments.equipment_id", // TODO: SUBSTITUIÇÃO / DEVOLUÇÃO
        label: "Equipamento",
        type: "select",
        placeholder: "Selecione o equipamento",
        icon: faBoxOpen,
        fullWidth: true,
        isMulti: false,
      }),
      createField({
        id: "equipments.details", // TODO: ALUGUEL / SUBSTITUIÇÃO / DEVOLUÇÃO
        label: "Detalhes",
        type: "textarea",
        placeholder: "Digite os detalhes",
        fullWidth: true,
        icon: faFileAlt,
      }),
    ],
  },
  {
    section: "Insumos",
    array: true,
    fields: [
      createField({
        id: "items.movement_type_id",
        label: "Tipo de Movimento",
        type: "select",
        placeholder: "Digite o tipo de movimento",
        icon: faClipboardCheck,
        isClearable: true,
      }),
      createField({
        id: "items.department_id",
        label: "Departamento",
        type: "select",
        placeholder: "Selecione o departamento",
        icon: faClipboardCheck,
        isClearable: true,
      }),
      createField({
        id: "items.product_id",
        label: "Insumo",
        type: "select",
        placeholder: "Selecione o insumo",
        icon: faBoxOpen,
        isMulti: false,
      }),
      createField({
        id: "items.quantity_product",
        label: "Quantidade",
        type: "number",
        placeholder: "Digite a Quantidade",
        icon: faBoxOpen,
      }),
      createField({
        id: "items.address_id",
        label: "Endereço",
        type: "select",
        placeholder: "Selecione o endereço",
        icon: faMapMarkerAlt,
      }),
      createField({
        id: "items.location_id",
        label: "Localização",
        type: "select",
        placeholder: "Selecione a localização",
        icon: faLocationPin,
        notRequired: true,
      }),
      createField({
        id: "items.details",
        label: "Detalhes",
        type: "textarea",
        placeholder: "Digite os detalhes",
        fullWidth: true,
        icon: faFileAlt,
      }),
    ],
  },
];
